// extracted by mini-css-extract-plugin
export default {"paymentHistoryContainer":"PaymentHistory_paymentHistoryContainer__X3Hle","noteText":"PaymentHistory_noteText__wQFid"};